export enum ExportType {
    Export = 1,
    Refer = 2
}

export enum QuoteType {
    Dict = 1,
    Dir = 2,
    Item = 3
}

export const exportTypes = {
    [ExportType.Export]: '导出',
    [ExportType.Refer]: '在线引用',    
}